import { Stack } from "@mui/material";
import { useIsDesktop } from '@repo/ui';

import React, { type FC, type PropsWithChildren } from "react";

export const CheckContactInfoLayout: FC<PropsWithChildren & { ContactInfoCheck: React.ComponentType }> = ({ children, ContactInfoCheck }) => {
	const isD = useIsDesktop();

	return (
		<Stack
			sx={{
				position: "relative",
				flexGrow: 1,
				alignItems: { md: "flex-start" },
			}}
		>
			{isD && <ContactInfoCheck />}
			<Stack
				spacing={5}
				sx={{
					flexGrow: 1,
					width: { md: "48%" },
					overflowY: "hidden",
					mx: { md: -3, xs: 0 },
					pt: isD ? 8 : 0,
					pb: 3,
					px: { md: 3, xs: 4 },
				}}
			>
				{children}
			</Stack>
		</Stack>
	);
};

